import axios from "axios";
import {
  ITEM_CREATE_REQUEST,
  ITEM_CREATE_SUCCESS,
  ITEM_CREATE_FAIL,
  ALL_ITEM_VIEW_REQUEST,
  ALL_ITEM_VIEW_SUCCESS,
  ALL_ITEM_VIEW_FAIL,
  ITEM_UPDATE_REQUEST,
  ITEM_UPDATE_SUCCESS,
  ITEM_UPDATE_FAIL,
  ITEMS_BY_ID_SUCCESS,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createItems =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: ITEM_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(
        `${SERVERADDRESS}/v1/items/createItems`,
        obj
      );
      dispatch({
        type: ITEM_CREATE_SUCCESS,
        payload: data,
      });
      // callback && callback(data.id);
    } catch (err) {
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: ITEM_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getAllItems = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_ITEM_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/items/getAllItems`,
      obj
    );

    localStorage.setItem("items", JSON.stringify(data.slice(0, 200)));
    dispatch({
      type: ALL_ITEM_VIEW_SUCCESS,
      payload: data.slice(0, 200),
    });
    callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_ITEM_VIEW_FAIL,
      payload: err,
    });
  }
};

export const updateItem = (obj, handleSuccess) => async (dispatch) => {
  dispatch({
    type: ITEM_UPDATE_REQUEST,
  });
  try {
    const { data } = await axios.patch(
      `${SERVERADDRESS}/v1/items/updateItems`,
      obj
    );
    handleSuccess();
    // notifySuccess("Updated successfully !");
    dispatch({
      type: ITEM_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    // notifyFailure(err?.response?.data?.message);
    dispatch({
      type: ITEM_UPDATE_FAIL,
      payload: err,
    });
  }
};

// export const setItemData = (obj) => async (dispatch) => {
//   dispatch({
//     type: ITEMS_BY_ID_SUCCESS,
//     payload: obj,
//   });
// };
export const setItemData = (obj) => async (dispatch) => {
  dispatch({
    type: ITEMS_BY_ID_SUCCESS,
    payload: obj,
  });
};
